export default __webpack_public_path__ + "static/media/twitter.c3a75483.svg";